import React from "react";
import { Flex, Text, Image, Link } from "@chakra-ui/react";
import { StyleSheet, css } from "aphrodite";

import "./mediaTable.css";
import { MEDIA_ITEMS } from "./MediaData";

// (recommended) React components should be PascalCase
function Media() {
  return (
    <>
      <Flex direction="column" align="center" width="70%" marginLeft="15%" marginRight="15%">
        <Text
          style={{
            maxWidth: "100%",
            justifyContent: "center",
            fontSize: 30,
            margin: "1%",
            fontWeight: "bolder",
            textShadow: "1px 1px gray",
            textAlign: "center",
            textDecorationLine: "underline",
          }}
        >
          NEXTCONLAB MEDIA
        </Text>
      </Flex>

      <div className="tableContainer">
        <table className="mediaTable">
          <thead>
            <tr>
              <th>Source</th>
              <th>Link</th>
              <th>HeadLine</th>
            </tr>
          </thead>

          <tbody>
            {MEDIA_ITEMS.map((item, idx) => (
              <tr key={`media-${idx}`}>
                {/* Source */}
                <td>
                  {item.image ? (
                    <>
                      <br />
                      <Image
                        src={item.image.src}
                        alt={item.image.alt || "media"}
                        className={css(styles.images)}
                        style={item.imageStyle || undefined}
                      />
                    </>
                  ) : null}
                </td>

                {/* Link */}
                <td>
                  <br />
                  {/* optional "side image" like your med7.jpg case */}
                  {item.link?.sideImage ? (
                    <>
                      <Image
                        src={item.link.sideImage.src}
                        alt={item.link.sideImage.alt || "media side"}
                        className={css(styles.images)}
                      />
                      <br />
                    </>
                  ) : null}

                  {item.link?.href ? (
                    <Link href={item.link.href} className={css(styles.Newslink)} target="_blank" rel="noreferrer">
                      {item.link.label}
                    </Link>
                  ) : null}
                </td>

                {/* Headline */}
                <td>
                  <Text className={css(styles.Newscontent)}>
                    <br />
                    {item.headline}
                  </Text>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

const styles = StyleSheet.create({
  images: {
    maxHeight: "250px",
    objectFit: "contain", // (fix) replaces invalid "fit"
  },
  Newslink: {
    textDecoration: "underline",
    width: "100%",
    color: "darkblue",
    fontWeight: "bold",
    wordBreak: "break-word", // helps long urls
  },
  Newscontent: {
    width: "100%",
    fontWeight: "bold",
  },
});

export default Media;